module.exports = __webpack_public_path__ + "static/media/dont-make-me-think.f1701866.jpg";